// extracted by mini-css-extract-plugin
module.exports = {"coverImg":"MediaDetailsCoverImg_coverImg__hDn1T"};